import _ from "lodash";
import { Activity } from "../types/Activity";
import { ProductUnion } from "../types/ProductUnion";

export const activitiesFilterString = (product: ProductUnion, filter: Partial<Activity<string>>) => {
  const urlFilterParams = new URLSearchParams(
    // @ts-ignore
    _.merge({ case: product?.backofficeCase ? product.backofficeCase["@id"] : 0 }, filter)
  );
  return urlFilterParams.toString();
};
